"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _hls = _interopRequireWildcard(require("hls.js"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var HlsLoader = /*#__PURE__*/function (_Hls$DefaultConfig$lo) {
  (0, _inherits2["default"])(HlsLoader, _Hls$DefaultConfig$lo);

  var _super = _createSuper(HlsLoader);

  function HlsLoader(config) {
    var _this;

    (0, _classCallCheck2["default"])(this, HlsLoader);
    _this = _super.call(this, config);
    _this.fragments = config.fragments;
    return _this;
  }

  (0, _createClass2["default"])(HlsLoader, [{
    key: "load",
    value: function load(context, config, callbacks) {
      if (context.url.indexOf('?') !== -1) {
        (0, _get2["default"])((0, _getPrototypeOf2["default"])(HlsLoader.prototype), "load", this).call(this, context, config, callbacks);
        return;
      }

      var match = this.fragments.find(function (fragment) {
        return fragment.preSignedUrl.includes(context.url);
      });

      if (!match) {
        throw new Error('Failed to find pre signed url');
      }

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(HlsLoader.prototype), "load", this).call(this, _objectSpread({}, context, {
        url: match.preSignedUrl
      }), config, callbacks);
    }
  }]);
  return HlsLoader;
}(_hls["default"].DefaultConfig.loader);

var _default = HlsLoader;
exports["default"] = _default;